export const FirebaseConfig = {
	"projectId": "mototaxi-lavras-393220",
	"appId": "1:820620068574:web:41c9641183660db0a0644f",
	"databaseURL": "https://mototaxi-lavras-393220-default-rtdb.firebaseio.com",
	"storageBucket": "mototaxi-lavras-393220.appspot.com",
	"locationId": "southamerica-east1",
	"apiKey": "AIzaSyBKZ1TfPhnBv7NZcK13kVkGTkYEF7b9gNs",
	"authDomain": "mototaxi-lavras-393220.firebaseapp.com",
	"messagingSenderId": "820620068574",
	"measurementId": "G-7XRTD7W252"
};